import { render, staticRenderFns } from "./Webshop.vue?vue&type=template&id=c7b0d2a4&scoped=true&"
import script from "./Webshop.vue?vue&type=script&lang=js&"
export * from "./Webshop.vue?vue&type=script&lang=js&"
import style0 from "./Webshop.vue?vue&type=style&index=0&id=c7b0d2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b0d2a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardSubtitle,VDatePicker,VDialog,VSimpleTable,VSpacer})
